/**
 * DS-internal hook : la dernière valeur restée la même pendant `ms` — celle d'une mesure qui a fini de
 * bouger. La première (quand rien n'était posé, `null`) passe tout de suite ; les suivantes attendent que la
 * valeur se tienne. Pour ce qui coûte à refaire à chaque image et ne se voit pas au repos (l'orbite du tandem,
 * réglée sur la scène pendant qu'une barre s'ouvre au-dessus d'elle). Deux valeurs sont les mêmes quand elles
 * sont identiques (`Object.is`) : une mesure inchangée garde son objet.
 */
import { useEffect, useState } from "react"

export function useSettled<T>(value: T, ms: number): T {
    // État d'interface : la valeur posée.
    const [settled, setSettled] = useState(value)

    useEffect(() => {
        if (Object.is(settled, value)) return undefined
        if (settled == null) {
            setSettled(value)
            return undefined
        }
        const id = setTimeout(() => setSettled(value), ms)
        return () => clearTimeout(id)
    }, [value, settled, ms])

    return settled
}
